module.exports = __webpack_public_path__ + "img/illu_hl.d6af4b8c.svg";